(function () {
    'use strict';

    angular.module("imApp").factory("skillsCertificatesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSkillsCertificates: function (parms) {
                return $ihttp.post({
                    method: 2501,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
